import React, { memo, useEffect } from "react";
import "./notFound.css";
import Header from "src/components/Header/Header";
import UnavailableLogo from "src/images/unavailable.png";

const NotAvailable = memo(() => {
  useEffect(() => {
    const element = document.getElementById("APP");
    if (element.firstChild) {
      element.firstChild.style.display = "none";
    }
  }, []);

  return (
    <>
      <Header style={{ position: "fixed", width: "100%", top: 0 }} />
      <div id="not-available-container">
        <div id="not-available-content">
          <img src={UnavailableLogo} alt="unavailable" />
          <h2 id="not-available-title">Order Journal Unavailable</h2>
          <p id="not-available-description">
            Sorry, we couldn't find the journal you're looking for. The link may
            be incorrect, or the order is no longer in our system.
          </p>
        </div>
      </div>
    </>
  );
});

export default NotAvailable;
